'use client';
import React, { useEffect, useState } from 'react';
import Script from 'next/script';
import { useChatbotVisibility } from '@/hooks/useChatbotVisibility';
import useFeature from '@/hooks/useFeature';

const ZendeskWidget = () => {
  const chatId = process.env.NEXT_PUBLIC_ZENDESK_ENVIRONMENT_ID || null;
  const { isDisabled } = useChatbotVisibility();
  const enableAda = Boolean(useFeature('retention-enable-ada'));
  const [isAda, setIsAda] = useState(false);

  useEffect(() => {
    setIsAda(enableAda);
  }, [enableAda]);

  useEffect(() => {
    if (isDisabled || !chatId) return;

    // show or hide the widget based on device type.
    const zendeskWidgetEl = document?.getElementById('launcher');
    const display = 'block';

    if (zendeskWidgetEl) zendeskWidgetEl.style.display = display;
  }, [isDisabled, chatId]);

  if (isDisabled || !chatId) return null;

  return (
    !isAda && (
      <Script
        type="text/javascript"
        async={true}
        src={`https://static.zdassets.com/ekr/snippet.js?key=${chatId}`}
        id="ze-snippet"
      />
    )
  );
};

export default ZendeskWidget;
